import { util } from 'jointjs';

export default () => util.uuid();
